import { useNavigate } from "react-router-dom";
import { MessageCircle, Zap } from "lucide-react";
import { useLead } from "@/context/LeadContext";

export function MobileCTA() {
    const nav = useNavigate();
    const { openLead } = useLead();
    return (
        <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 glass border-t border-brandborder/60 grid grid-cols-2 gap-2 p-2.5 pb-[max(0.625rem,env(safe-area-inset-bottom))]" data-testid="mobile-bottom-cta">
            <button onClick={() => nav("/build-my-brand")} className="btn-gold rounded-xl py-3 text-sm font-bold flex items-center justify-center gap-1.5" data-testid="mobile-cta-get-started">
                <Zap className="w-4 h-4" /> Build My Brand
            </button>
            <button onClick={() => openLead()} className="btn-ghost-cream rounded-xl py-3 text-sm font-semibold flex items-center justify-center gap-1.5" data-testid="mobile-cta-whatsapp">
                <MessageCircle className="w-4 h-4 text-growth" /> Talk to Expert
            </button>
        </div>
    );
}
